import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-demo-claims-registration',
  templateUrl: './demo-claims-registration.component.html',
  styleUrls: ['./demo-claims-registration.component.scss']
})
export class DemoClaimsRegistrationComponent implements OnInit {

  constructor(
      private router: Router,
  ) { }
  ngOnInit() {
  }
  
  dataSet = [ {},{} ];

  /* Navigate to new Registration */
  newRegn() {
    this.router.navigate(['/app/claims/details/registration/claims-health'], { queryParams: { }, replaceUrl: false } );
  }
}
